import { useFilterContext } from '../../../context/FilterContext';

import ContentFilter from './ContentFilter/ContentFilter';
import './FilterServiceRequest.scss';

const FilterForm = () => {
  const {
    formikFilters: { handleSubmit }
  } = useFilterContext();

  return (
    <div className="content-filter narrow-scrollbar">
      <form onSubmit={handleSubmit}>
        <ContentFilter />
      </form>
    </div>
  );
};

export default FilterForm;
